import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class EmptyTenantLeaseSuiteIdError extends CodedError {
  static get errorName() {
    return errorCodeTypes.emptyTenantLeaseSuiteIdError.code;
  }

  constructor(message = errorCodeTypes.emptyTenantLeaseSuiteIdError.message) {
    super(message);
    this.code = errorCodeTypes.emptyTenantLeaseSuiteIdError.code;
    this.message = `${message} ${errorCodeTypes.emptyTenantLeaseSuiteIdError.code}`;
    this.name = errorCodeTypes.emptyTenantLeaseSuiteIdError.name;
  }
}
